const callback_on_click = (event, node_to_match, binding) => {
    const callback = binding.value;

    if (!callback || typeof callback !== 'function') {
        return;
    }

    const path = event.path || (typeof event.composedPath === 'function' ? event.composedPath() : []);
    const prevented = path.length
        ? path.indexOf(node_to_match) !== -1
        : node_to_match.contains(event.target);

    if (!prevented) {
        callback(event);
    }
};


export default {
    inserted(el, binding) {
        el.clickOutsideEvent = (event) => {
            callback_on_click(event, el, binding);
        };

        document.addEventListener('click', el.clickOutsideEvent, false);
    },

    unbind(el) {
        document.removeEventListener('click', el.clickOutsideEvent, false);
        delete el.clickOutsideEvent;
    },
}